import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import InappDealershipCard from './InappDealershipCard';

const useStyles = makeStyles(() => ({
  titleContainer: {
    height: '60px',
    color: '#10182B',
    border: '1px solid #F4F4F4',
    padding: '20px',
  },
  titleText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '140%',
    textAlign: 'center',
    height: '14%',
    justifyContent: 'center',
  },
  contentContainer: {
    background: '#F9FAFB',
    textAlign: 'center',
    height: '86%',
    overflow: 'auto',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  emptyContainer: {
    width: '237px',
    height: '145px',
  },
  emptyText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '140%',
    textAlign: 'center',
    color: '#10182B',
    marginBottom: '18px',
  },
}));

const RightSideInapp = () => {
  const classes = useStyles();
  const dealershipList = useSelector((state) => state.inappData.selectedInappDealershipList);

  return (
    <Grid container direction="column" style={{ height: '450px' }}>
      <Grid item className={classes.titleContainer}>
        <Grid container direction="row" justifyContent="flex-start">
          <Grid item className={classes.titleText}>
            Dealerships
          </Grid>
        </Grid>
      </Grid>
      {dealershipList?.length ? (
        <Grid item className={classes.contentContainer}>
          <Grid container direction="column" alignContent="center">
            {dealershipList.map((d) => d && <InappDealershipCard data={d} />)}
          </Grid>
        </Grid>
      ) : (
        <Grid item className={classes.contentContainer}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            alignContent="center"
            style={{ height: '100%' }}
          >
            <Grid item className={classes.emptyContainer}>
              <Typography className={classes.emptyText}>
                You dont have any Dealership added for the Inapp. It is applied on all dealerships.
              </Typography>
            </Grid>
            <Grid item></Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default RightSideInapp;
